/**
 * 生产运维内容-中文版
 */
export default {
  //构建内容
  build() {
    return [
      {
        title: 'app-businessSystem1',//业务系统
        content: [{
          name: 'prod-app-sevens',//sevens主页
          id: 1,
          link: 'https://www.sevensmarketing.com',
          logoColor: '#444444',
          img: require('@/assets/logo/sevens_logo.png')
        }, {
          name: 'prod-app-pingworth',//品沃主页
          id: 2,
          link: 'https://pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pingworth_logo.jpg')
        }, {
          name: 'prod-app-store',//'哇鹅-商家端',
          id: 3,
          link: 'https://www.whaee.com',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'prod-app-sensation',//'哇鹅-红人端',
          id: 4,
          link: 'https://www.whatsworth.com',
          logoColor: '#FF3D48',
          img: require('@/assets/logo/pingworth.png')
        },{
          name: 'prod-app-whaee-operator',//哇鹅-商家端 - Sevens运营账户入口
          id: 5,
          link: 'https://console.whaee.com/v2/operator/login',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'prod-app-mms',//MMS
          id: 6,
          link: 'https://mms.pingworth.com',
          logoColor: '#3f48cc',
          img: require('@/assets/logo/mmsLogo.png')
        }, {
          name: 'prod-app-kpa',//KPA
          id: 7,
          link: 'https://kpa.pingworth.com',
          logoColor: '#7e40c7',
          img: require('@/assets/logo/kpaLogo.png')
        }, {
          name: 'prod-app-cs',//CS
          id: 8,
          link: 'https://cs.pingworth.com',
          logoColor: '#A349A4',
          img: require('@/assets/logo/csLogo.png')
        }, {
          name: 'prod-app-fms',//FMS
          id: 9,
          link: 'https://fms.pingworth.com',
          logoColor: '#57000d',
          img: require('@/assets/logo/fmsLogo.png')
        }, {
          name: 'prod-app-dms',//DMS
          id: 10,
          link: 'https://dms.pingworth.com',
          logoColor: '#518217',
          img: require('@/assets/logo/dmsLogo.png')
        }, {
          name: 'prod-pw-os',//品沃OS
          id: 12,
          link: 'https://os.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pw_os_logo.png'),
          isDeveloper: true
        }]
      },{
        title: 'app-businessSystem2',//业务系统
        content: [{
          name: 'uat-app-whaee-operator',//哇鹅-商家端 - Sevens运营账户入口
          id: 1,
          link: 'https://uat.console.whaee.com/v2/operator/login',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'uat-app-mms',//MMS
          id: 3,
          link: 'https://uat.mms.pingworth.com',
          logoColor: '#3f48cc',
          img: require('@/assets/logo/mmsLogo.png')
        }, {
          name: 'uat-app-kpa',//KPA
          id: 4,
          link: 'https://uat.kpa.pingworth.com',
          logoColor: '#7e40c7',
          img: require('@/assets/logo/kpaLogo.png')
        }, {
          name: 'uat-app-cs',//CS
          id: 6,
          link: 'https://uat.cs.pingworth.com',
          logoColor: '#A349A4',
          img: require('@/assets/logo/csLogo.png')
        }, {
          name: 'uat-app-fms',//FMS
          id: 7,
          link: 'https://uat.fms.pingworth.com',
          logoColor: '#57000d',
          img: require('@/assets/logo/fmsLogo.png')
        }, {
          name: 'uat-app-dms',//DMS
          id: 8,
          link: 'https://uat.dms.pingworth.com',
          logoColor: '#518217',
          img: require('@/assets/logo/dmsLogo.png')
        }, {
          name: 'uat-pw-exception',//品沃异常
          id: 10,
          link: 'http://uat.ex.pingworth.com',
          logoColor: '#DDDDDD',
          img: require('@/assets/logo/pw_ex_logo.png'),
          isDeveloper: true
        }, {
          name: 'uat-pw-os',//品沃OS
          id: 11,
          link: 'https://uat.os.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pw_os_logo.png'),
          isDeveloper: true
        },{
          name: 'uat-app-store',//'哇鹅-商家端',
          id: 12,
          link: 'https://uat.whaee.com',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'uat-app-sensation',//'哇鹅-红人端',
          id: 13,
          link: 'http://uat.whatsworth.com',
          logoColor: '#FF3D48',
          img: require('@/assets/logo/pingworth.png')
        }]
      },
      {
        title: 'proOps-archery',
        content: [{
          name: 'proOps-archery',
          id: 1,
          link: 'https://archery.whaee.com/',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/ARCHERY.jpg')
        }]
      },
      {
        title: 'proOps-czsm',
        content: [{
          name: 'proOps-fbsq',
          id: 1,
          link: 'https://nsksiwszvz.feishu.cn/base/Su1RblrKAa19ZQs0ctucbIDynRx?table=tbllmuQqORerddZk&view=vew9mCGWw3#CategoryAutomatedUpdate',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/file.jpg')
        }, {
          name: 'proOps-gdsh',
          id: 2,
          link: 'https://nsksiwszvz.feishu.cn/docx/DuwxdoMo5ork5dxWMsWcQTcrndg',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/file.jpg')
        }, {
          name: 'proOps-item',
          id: 3,
          link: 'https://nsksiwszvz.feishu.cn/sheets/OIqlstCLMh5IQGths2PcuQX9nlf',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/file.jpg')
        }]
      },
      {
        title: 'proOps-operation',//运维
        content: [{
          name: 'proOps-Jenkins',//Jenkins
          id: 1,
          link: 'http://dev.jenkins.whaee.net/',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/jenkins_logo.png')
        },{
          name: 'proOps-kibana',//kibana
          id: 2,
          link: 'http://kibana.whaee.com/app/discover#',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/elastic_logo.jpg')
        },{
          name: 'proOps-sonarqube',//sonarqube
          id: 3,
          link: 'http://sonarqube.whaee.net/projects',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/sonarqube_logo.jpeg')
        },{
          name: 'proOps-kiali',//kiali
          id: 3,
          link: 'http://10.235.101.233:30001',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/kiali_logo.png')
        },{
          name: 'proOps-grafana',//Grafana
          id: 4,
          link: 'http://grafana.whaee.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/grafana_logo.png')
        },{
          name: 'proOps-prometheus',//Prometheus
          id: 5,
          link: 'http://10.235.101.233:30002',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/prometheus_logo.png')
        },{
          name: 'proOps-en-kibana',//Prometheus
          id: 6,
          link: 'http://10.235.178.162:5601/',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/elastic_logo.jpg')
        }]
      },
      {
        title: 'proOps-base-support',//基础支持
        content: [{
          name: 'proOps-apollo',//Apollo
          id: 1,
          link: 'http://pro.apollo.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/apollo_logo.png')
        }, {
          name: 'proOps-otter',//Otter
          id: 2,
          link: 'http://pro.otter.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/otter_logo.png')
        }, {
          name: 'proOps-xxl-job',//XXL-JOB
          id: 3,
          link: 'http://xxl-job.pingworth.com',
          logoColor: '#d2d6de',
          img: require('@/assets/logo/xxl-logo.png')
        }, {
          name: 'proOps-es-head',//elasticsearch-head
          id: 4,
          link: 'http://es-head.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/es-head-logo.png')
        }, {
          name: "proOps-dolphinscheduler", //DolphinScheduler
          id: 5,
          link: "https://dolphinscheduler.whaee.com/dolphinscheduler",
          logoColor: "#d2d6de",
          img: require("@/assets/logo/dolphinscheduler_logo.png"),
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/content/content_proOps.js